export interface Tag {
  id?: number;
  color: string;
  description: string;
  name: string;
  code?: string;
  visible?: boolean;
}

export interface EditTagDto extends Tag {
  id: number;
}
export enum TagTypeNames {
  CREDIT = 'CREDIT',
  CLIENT = 'CLIENT'
}
export enum TagActionNames {
  ADD = 'ADD',
  DELETE = 'DELETE'
}

export interface TagPreference {
  id: number;
  order: number;
  visible: boolean;
}
